import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { object, string } from 'yup';
import { hasValue } from 'globalutils/fmUtils';
import { emailRegExp } from 'globalutils/constants';

const Form = lazy(() => import(`globalcomponents/UI/Form/${window?.$environment?.CURRENT_LAYOUT}`));

const ForgotPasswordForm = ({ apiStatus, requestForgotPassword, clearApiStatus, Styled, innerComponent, i18n }) => {
  const apiId = 'forgotPassword';
  const hasApiStatus = hasValue(apiStatus.status, 'api', apiId);
  const RenderComponent = lazy(() => import(`@/${innerComponent}`));
  const NewUI = window?.$environment?.clutchNewUI;

  return (
    <Styled.LoginWrapper newUI={NewUI}>
      <div className="formLogin forgotPassword">
        <Form
          type="server"
          direction="column"
          initialValues={{
            email: '',
          }}
          RenderComponent={RenderComponent}
          handleOnSubmit={(fields) => {
            requestForgotPassword({
              data: fields,
              apiId,
            });
          }}
          customProps={{
            hasApiStatus,
            clearApiStatus,
            Styled,
            i18n,
          }}
          validationSchema={object().shape({
            email: string()
              .matches(emailRegExp, i18n.t('common.emailValidationMessage'))
              .required(i18n.t('common.fieldRequiredMessage')),
          })}
        />
      </div>
    </Styled.LoginWrapper>
  );
};

export default ForgotPasswordForm;

ForgotPasswordForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  requestForgotPassword: PropTypes.func.isRequired,
  clearApiStatus: PropTypes.func.isRequired,
  Styled: PropTypes.object.isRequired,
  i18n: PropTypes.array.isRequired,
};
